import { render, staticRenderFns } from "./WorkflowPanel.vue?vue&type=template&id=73355388&scoped=true"
import script from "./WorkflowPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowPanel.vue?vue&type=style&index=0&id=73355388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73355388",
  null
  
)

export default component.exports